import { p as t } from "../parseISO-wlfIB_QJ.js";
function n(r) {
  return typeof r == "number" ? new Date(r) : r ? typeof r == "string" ? t(r) : r : /* @__PURE__ */ new Date();
}
export {
  n as default
};
//# sourceMappingURL=normalizeDate.js.map
